// RoadmapSection.jsx
import { forwardRef } from "react";
import "./RoadmapSection.css";

const roadmapData = [
  { date: "Soon", text: "Character Mint Begins"},
  { date: "Oct. 2025", text: "Daily/Weekly Quests"},
  { date: "Q4 2025", text: "Idle Game will roll out with weekly updates in October/November/December."},
  { date: "Q1 2026", text: "First Official Campaigns + Idle Game Full Launch" },
  { date: "Q2 2026", text: "Community Campaigns" },
];

const RoadmapSection = forwardRef((props, ref) => {
  return (
    <section
      ref={ref}
      className="section roadmap"
      style={{
        backgroundImage: "url('/locs/hills-dewd.png')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="roadmap-overlay"></div>
      <h2 className="roadmap-title">Roadmap</h2>
      <div className="timeline">
        {roadmapData.map((item, idx) => (
          <div
            key={idx}
            className={`timeline-item ${idx % 2 === 0 ? "left" : "right"}`}
          >
            <div className="timeline-content">
              <span className="timeline-date">{item.date}</span>
              <p className="timeline-text">{item.text}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
});

export default RoadmapSection;
